import { render, staticRenderFns } from "./allergySetup.vue?vue&type=template&id=b196397e&"
import script from "./allergySetup.vue?vue&type=script&lang=js&"
export * from "./allergySetup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports